import { Button, Descriptions, Dropdown, Popconfirm, Tabs } from "antd";
import { Link, useNavigate, useParams, useRouteLoaderData } from "react-router";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import BackTitle from "../common/BackTitle";
import { api } from "../common/api";
import { date2locale } from "../common/common";
import Inspections from "../inspection/Inspections";
import VehicleDocuments from "../document/VehicleDocuments";
import VehicleSetupDocuments from "./VehicleSetupDocuments";

export default function VehicleSetup() {
  const data = useRouteLoaderData("setup");
  const navigate = useNavigate();

  return (
    <div style={{ width: "100%" }}>
      <BackTitle
        backEnabled={false}
        title="Dettagli allestimento"
        secondary={`ID: ${data.id}`}
        extra={
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  key: "deleteSetup",
                  danger: true,
                  icon: <DeleteOutlined />,
                  label: (
                    <Popconfirm
                      title="Conferma rimozione"
                      description="L'operazione è irreversibile. Procedendo, i dati verranno rimossi definitivamente."
                      onConfirm={() => api.vehicleSetup.delete(data.id).then(() => navigate(".."))}
                    >
                      Elimina
                    </Popconfirm>
                  ),
                },
              ],
            }}
          >
            <Button aria-label="Azioni allestimento" icon={<MoreOutlined />} />
          </Dropdown>
        }
      />
      <Descriptions
        layout="vertical"
        column={3}
        colon={false}
        title={
          <>
            Informazioni generali
            <Button
              type="link"
              aria-label="Modifica allestimento"
              icon={<EditOutlined />}
              onClick={() => navigate("edit")}
            />
          </>
        }
        items={[
          { key: "model", label: "Modello", children: data.model },
          { key: "type", label: "Categoria", children: data.type?.description },
          {
            key: "vehicle",
            label: "Veicolo",
            children: <Link to="../..">{data.vehicle?.plate}</Link>,
          },
          {
            key: "firstInspectionDate",
            label: "Data ultima ispezione o acquisto",
            children: data.firstInspectionDate && date2locale(data.firstInspectionDate),
          },
          {
            key: "inspectionMonths",
            label: "Revisione ogni",
            children:
              data.type?.inspectionMonths != null ? `${data.type.inspectionMonths} mesi` : "",
          },
        ]}
      />
      <Tabs
        destroyOnHidden
        items={[
          !!data.type?.inspectionMonths && {
            key: "inspections",
            label: "Revisioni",
            children: <Inspections key={data.id} type="SETUP" id={data.id} />,
          },
          {
            key: "documents",
            label: "Documenti",
            children: <VehicleSetupDocuments key={data.id} setupId={data.id} />,
          },
        ].filter(Boolean)}
      />
    </div>
  );
}
